import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import { Link } from "react-router-dom";
import { ActionMenu } from "layouts/common/buttons";
import { TextLink } from "layouts/common/buttons";

export default function data(roles = [], handleDelete) {
  const rows = () =>
    roles.map((role) => {
      const { permissions } = role;

      return {
        name: (
          <TextLink
            link={`/roles/${role.id}/detail`}
            text={role.name}
          />
        ),

        permissions: (
          <MDBox
            display="flex"
            alignItems="center"
            flexWrap="wrap"
            gap={1}
            sx={{
              maxWidth: "700px",
            }}
          >
            {permissions.slice(0, 3).map((permission, index) => (
              <MDBox
                key={index}
                px={1.5}
                py={0.5}
                sx={{
                  backgroundColor: "#f4f6f8",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                }}
              >
                <MDTypography
                  variant="button"
                  sx={{
                    fontSize: "0.75rem",
                    color: "#1e293b",
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                >
                  {permission}
                </MDTypography>
              </MDBox>
            ))}
            {permissions.length > 3 && (
              <Link to={`/roles/${role.id}/detail`}>
                <MDTypography
                  variant="caption"
                  sx={{
                    ml: 1,
                    color: "#1976d2",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                >
                  Show more…
                </MDTypography>
              </Link>
            )}
          </MDBox>
        ),

        dropdown: (
          <ActionMenu
            entity={role}
            basePath="roles"
            onDelete={() => handleDelete(role.id)}
          />
        ),
      };
    });

  return {
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Permissions", accessor: "permissions", align: "left" },
      { accessor: "dropdown", align: "right" },
    ],
    rows: rows(),
  };
}
